import Hero from "./Hero/Hero";
import LatestCourses from "Components/Sliders/LatestCourses";
import { useTranslation } from "react-i18next";
import Container from "Components/Container/Container";
import useApiQuery from "Hooks/useApiQuery";
import { useEffect, useContext } from "react";
import IsLoading from "Components/RequestHandler/IsLoading";
import Reels from "./Reels/Reels";
import CategorySlider from "Components/Sliders/CategorySlider";
import InstructorProfileSlider from "Components/Sliders/InstructorProfileSlider";
import FrequentlyAskedQuestions from "Components/FQ/FrequentlyAskedQuestions";
import { CategoriesContext } from "Context/General/CategoriesContext";
import HomeBanner from "Components/HomeBanner/HomeBanner";
import HeroActionCard from "Components/HeroActionCard/HeroActionCard";
import PlatformExperience from "Components/PlatformExperience/PlatformExperience";

const Home = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useApiQuery("home");
  const { setCategoriesData } = useContext(CategoriesContext);

  // Populate categories context from home response
  useEffect(() => {
    if (data?.data) {
      setCategoriesData(data.data.categories);
    }
  }, [data]);

  if (isLoading) {
    return <IsLoading />;
  }

  if (data) {
    return (
      <main className="overflow-hidden">
        <Hero courses={data?.data?.featured_courses} hero={data?.data?.hero} />

        {/* Sections with consistent spacing — on mobile the Hero's own pb provides the top gap, so no pt here */}
        <div className="flex flex-col gap-y-12 lg:gap-y-section-gap-lg pt-0 lg:pt-section-gap-lg pb-12 lg:pb-section-gap-lg">
          {/* Hero action card (steps + CTA) — mobile only, sits as its own section */}
          <HeroActionCard />

          {/* Smart Banner — sits in the section flow so it gets the same gap as other sections */}
          <HomeBanner />

          {/* Platform Experience — stats + differentiators + positioning */}
          <PlatformExperience data={data?.data?.platform_experience} />

          {/* Courses first — show what they're buying */}
          <LatestCourses
            data={data?.data?.newlyAddedCourses}
            title={t("for_you.new_to_master_class")}
          />

          {/* Browse by category */}
          <Container>
            <CategorySlider />
          </Container>

          {/* Instructors — faces build trust */}
          {data?.instructor_profile && data.instructor_profile.length > 0 && (
            <Container>
              <InstructorProfileSlider
                data={data.instructor_profile}
                title={t("for_you.our_instructors")}
              />
            </Container>
          )}

          {/* Trending / Reels */}
          <Reels trending={data?.data?.trending} />

          {/* FAQ — handles objections */}
          <FrequentlyAskedQuestions
            title={t("home.faq_title")}
            items={data?.data?.faq}
          />
        </div>
      </main>
    );
  }
};

export default Home;
